"use strict";
/**
 *
 *
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var forEach_1 = __importDefault(require("lodash/forEach"));
var isObject_1 = __importDefault(require("lodash/isObject"));
var uniq_1 = __importDefault(require("lodash/uniq"));
var UrlSerializable_1 = __importDefault(require("./UrlSerializable"));
var BaseService_1 = require("../BaseService");
var next_tick_1 = __importDefault(require("next-tick"));
var Observable_1 = require("../Observable");
/**
 *  parses BI-specific url fragment in format like
 *   #trends/<guid>?a=a&b=b
 *   #/ds/
 *  return structure
 *  {
 *    path: string[];
 *    segment: string;
 *    segmentId: string | number
 *    route: string;             -- if segment === 'ds'
 *    search: string;
 *  }
 */
function parseBIURLFragment(fragment) {
    var pathStr = fragment;
    var search = '';
    if (fragment.match(/^#+(.*?)(?:\?(.*))?$/)) {
        pathStr = RegExp.$1;
        search = RegExp.$2 || '';
    }
    else if (fragment !== '') {
        console.assert(false, 'Invalid URL Fragment', fragment);
    }
    var path = pathStr.split('/');
    if (path[0] === '') {
        path.splice(0, 1);
    }
    var segment = path[0] ? decodeURIComponent(path[0]) : null;
    var segmentId = path[1] ? decodeURIComponent(path[1]) : null;
    var route = path[2] ? decodeURIComponent(path[2]) : null;
    // some exceptions
    if (['map', 'trends', 'dashboard', 'dashboards', 'plots', 'dbg-dash', 'dbg-vizel'].indexOf(segment) !== -1) {
        route = segment;
        segment = 'ds';
    }
    if (route === 'plots') {
        route = 'trends';
    }
    return { path: path, segment: segment, segmentId: segmentId, route: route, search: search };
}
function serializeUrlMainPart(hash) {
    if (!hash.segment) {
        return '';
    }
    var result = "#/" + hash.segment;
    if (hash.segmentId === null) {
        return result;
    }
    result += "/" + hash.segmentId;
    var route = hash.route && hash.route[0] === '#' ? hash.route.slice(1) : hash.route;
    if (!route) {
        return result;
    }
    result += "/" + route;
    return result;
}
// isObject([]) === true; isObject(Number) === true
function isHash(h) {
    return isObject_1["default"](h) && !Array.isArray(h) && typeof h !== 'function';
}
function extendHash(current, additional, structure) {
    if (additional === undefined)
        return current;
    if (!isHash(additional))
        return additional; // some bad value, or null - take it and it will be normalized in serialize
    if (!isHash(current))
        return additional;
    var r = {};
    forEach_1["default"](structure, function (type, key) {
        var value = _extendWithStructure(current[key], additional[key], type);
        if (value !== undefined)
            r[key] = value;
    });
    return r;
}
function _extendWithStructure(current, additional, structure) {
    if (isHash(structure))
        return extendHash(current, additional, structure);
    return additional !== undefined ? additional : current;
}
function extend(current, additional, structure) {
    var result = _extendWithStructure(current, additional, structure);
    // all unstructurized keys
    for (var key in current) {
        if (current.hasOwnProperty(key) && !(key in structure)) {
            result[key] = current[key];
        }
    }
    for (var key in additional) {
        if (additional.hasOwnProperty(key) && !(key in structure)) {
            result[key] = additional[key];
        }
    }
    return result;
}
var DEFAULT_URL_STRUCTURE = {
    parameters: [String],
    metrics: [String],
    preset: Number,
    locations: [Number],
    period: { start: String, end: String, type: Number },
    geo: { lat: Number, lng: Number, zoom: Number },
    autoscale: Boolean,
    loc: Boolean,
    mf: { e: Boolean, ls: [Number], m: String },
    dboard: String,
    dash: String,
    slide: String
};
var UrlState = /** @class */ (function (_super) {
    __extends(UrlState, _super);
    function UrlState() {
        var _this = _super.call(this) || this;
        _this._entryPoint = null;
        _this._changeHangler = function () {
            var url = _this.deserializeUrl(window.location.hash);
            var underscoredHash = {};
            Object.keys(_this._model)
                .filter(function (key) { return key.startsWith('_'); })
                .forEach(function (key) { return (underscoredHash[key] = _this._model[key]); });
            var newModel = __assign(__assign(__assign({}, url), { modals: _this._model.modals }), underscoredHash);
            _this._setModel(newModel);
        };
        _this._subscriptionManager = new Observable_1.ObservableHash(_this._model); // TODO: init with keys of URL_STRUCTURE
        window.addEventListener('hashchange', _this._changeHangler, false);
        return _this;
    }
    UrlState.prototype._createInitialModel = function () {
        if (!this._urlStructure)
            this._urlStructure = DEFAULT_URL_STRUCTURE;
        if (!this._urlSerializable)
            this._urlSerializable = new UrlSerializable_1["default"](DEFAULT_URL_STRUCTURE);
        var url = this.deserializeUrl(window.location.hash);
        return url;
    };
    UrlState.prototype.setEntryPoint = function (entryPoint) {
        this._entryPoint = entryPoint;
        this._setModel(this._createInitialModel());
    };
    UrlState.prototype.setUrlStructure = function (urlStructure) {
        this._urlStructure = urlStructure;
        this._urlSerializable = new UrlSerializable_1["default"](urlStructure);
        this._setModel(this._createInitialModel());
    };
    UrlState.prototype._smartUpdate = function (newModel, prevModel) {
        var keys = uniq_1["default"](Object.keys(newModel).concat(Object.keys(prevModel)));
        var result = {};
        var changedKeys = [];
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            var valueChanged = !isEqual_1["default"](newModel[key], prevModel[key]);
            if (valueChanged) {
                result[key] = newModel[key];
                changedKeys.push(key);
            }
            else {
                result[key] = prevModel[key];
            }
        }
        return result;
    };
    UrlState.prototype._isModelChanged = function (nextModel, currentModel) {
        return !isEqual_1["default"](nextModel, currentModel);
    };
    UrlState.prototype.buildUrl = function (additionalState) {
        var url = this.getModel();
        var newState = extend(url, additionalState, this._urlStructure);
        newState.segment = 'segment' in additionalState ? additionalState.segment : url.segment;
        newState.segmentId = 'segmentId' in additionalState ? additionalState.segmentId : url.segmentId;
        newState.route = 'route' in additionalState ? additionalState.route : url.route;
        newState.dataset = 'dataset' in additionalState ? additionalState.dataset : url.dataset;
        // when specified dataset, but not segment/segmentId, that means that should open /ds/...
        if (additionalState.dataset &&
            !('segment' in additionalState) &&
            !('segmentId' in additionalState)) {
            newState.segment = 'ds';
            newState.segmentId = additionalState.dataset;
        }
        if (!newState.dataset) {
            // null, undefined, ''
            delete newState.dataset;
        }
        var has = function (x) { return x in additionalState && additionalState[x] != null; };
        // hacky rules
        // rule 1. Specified parameters but not metrics => use parameters
        if (has('parameters') && !has('metrics')) {
            delete newState.metrics;
        }
        // rule 2. Specified both parameters and metrics => use metrics
        if (has('parameters') && has('metrics')) {
            delete newState.parameters;
        }
        // rule 3. No more 3 metrics on plots (when loc=true)
        if (newState.route === '#trends' && newState.loc && newState.parameters) {
            newState.parameters = newState.parameters.slice(-3);
        }
        // rule 4. No more 3 locations on plots (when loc=false)
        // if ((newState.route === '#trends') && !newState.loc && newState.locations) {
        //   newState.locations = newState.locations.slice(-3);
        // }
        // rule #5. If route is set, it might be ds. One might navigate to {route: '#map'} from ane segment
        if (newState.route) {
            newState.segment = 'ds';
            newState.dataset = newState.segmentId;
        }
        var sUrl = this._serializeUrl(newState);
        return sUrl;
    };
    UrlState.prototype._serializeUrl = function (hash) {
        var mainPart = serializeUrlMainPart(hash);
        var query = __assign({}, hash);
        delete query.segment;
        delete query.segmentId;
        delete query.route;
        delete query.dataset;
        delete query.modals;
        // delete keys that starts with _
        Object.keys(query)
            .filter(function (key) { return key.startsWith('_'); })
            .forEach(function (key) { return delete query[key]; });
        var searchStr = this._urlSerializable.serializeSearch(query);
        if (!mainPart && searchStr) {
            mainPart = '#/';
        }
        if (searchStr) {
            searchStr = '?' + searchStr;
        }
        return mainPart + searchStr;
    };
    UrlState.prototype.getModel = function () {
        return this._model;
    };
    UrlState.prototype._setModel = function (model) {
        _super.prototype._setModel.call(this, model);
        // notify handlers `subscribe`
        if (this._subscriptionManager) {
            this._subscriptionManager.setModel(model);
        }
    };
    UrlState.prototype.subscribe = function (items, callback) {
        return this._subscriptionManager.subscribe(items, callback);
    };
    UrlState.prototype.on = function (items, callback) {
        return this._subscriptionManager.subscribe(items, callback);
    };
    UrlState.prototype.navigate = function (additionalQuery, option) {
        //
        // TODO: rewrite to use native history object
        //       and to return promise once navigation is complete
        //
        var urlHash = this.buildUrl(additionalQuery);
        if (urlHash === window.location.hash) {
            // warn: url didn't change
            return;
        }
        if (!urlHash) {
            urlHash = '#';
        }
        if (option && option.replace) {
            history.replaceState(undefined, undefined, urlHash);
        }
        else {
            history.pushState(undefined, undefined, urlHash);
        }
        // must call manually
        // set immediate
        next_tick_1["default"](this._changeHangler);
    };
    UrlState.prototype.updateModel = function (partialModel, isReplace) {
        if (isReplace === void 0) { isReplace = false; }
        // strange fixes
        if ('locations' in partialModel) {
            if (partialModel.locations === null || Array.isArray(partialModel.locations)) {
                // ok
            }
            else {
                delete partialModel.locations;
            }
        }
        var newModel = __assign(__assign({}, this._model), partialModel);
        this.setModel(newModel, isReplace);
    };
    UrlState.prototype.setModel = function (model, replaceUrl) {
        if (replaceUrl === void 0) { replaceUrl = false; }
        var urlHash = this.buildUrl(model);
        if (urlHash !== window.location.hash) {
            if (!urlHash) {
                urlHash = '#';
            }
            if (replaceUrl) {
                history.replaceState(undefined, undefined, urlHash);
            }
            else {
                history.pushState(undefined, undefined, urlHash);
            }
            // no _changeHandler here
        }
        this._setModel(model);
    };
    UrlState.prototype._dispose = function () {
        if (this._subscriptionManager) {
            this._subscriptionManager.release();
            this._subscriptionManager = null;
        }
    };
    //
    //  return hash with all values from search and adds keys 'route' and 'dataset' if exists
    //
    UrlState.prototype.deserializeUrl = function (fragment) {
        var parsedFragment = parseBIURLFragment(fragment);
        var result = this._deserializeSearch(parsedFragment.search);
        result.segment = parsedFragment.segment;
        result.segmentId = parsedFragment.segmentId;
        result.route = parsedFragment.route !== null ? '#' + parsedFragment.route : null;
        if (this._entryPoint) {
            // overwrite defaults
            for (var _i = 0, _a = ['segment', 'segmentId', 'route']; _i < _a.length; _i++) {
                var key = _a[_i];
                if (!result[key] && this._entryPoint[key]) {
                    result[key] = this._entryPoint[key];
                }
            }
        }
        result.dataset = result.segment === 'ds' ? result.segmentId : null;
        return result;
    };
    UrlState.prototype._deserializeSearch = function (search) {
        return this._urlSerializable.deserializeSearch(search);
    };
    UrlState.getInstance = function () {
        if (!this._instance) {
            this._instance = new UrlState();
            if (typeof window !== 'undefined')
                window.__urlState = this._instance; // DEBUG
        }
        return this._instance;
    };
    UrlState.getModel = function () {
        return this.getInstance().getModel();
    };
    UrlState.subscribe = function (event, listener) {
        return this.getInstance().subscribe(event, listener);
    };
    UrlState.subscribeUpdatesAndNotify = function (listener) {
        return this.getInstance().subscribeUpdatesAndNotify(listener);
    };
    UrlState.subscribeUpdates = function (listener) {
        return this.getInstance().subscribeUpdates(listener);
    };
    UrlState.unsubscribe = function (listener) {
        return this.getInstance().unsubscribe(listener);
    };
    UrlState.navigate = function (additionalQuery, option) {
        this.getInstance().navigate(additionalQuery, option);
    };
    UrlState._instance = null;
    return UrlState;
}(BaseService_1.BaseService));
exports.UrlState = UrlState;
exports.urlState = UrlState.getInstance();
